import { StateProps } from './';

/**
 * Helper function to help determine which part of the UI
 * needs to be updated based on state changes
 * @param {StateProps} newState - new state
 * @param {StateProps} oldState - old state
 * @returns {Object} - object containing booleans
 */
export const getUpdateFlags = (state: StateProps, oldState: StateProps) => {
    const { loading, product } = state;

    return {
        loading: loading !== oldState.loading,
        offerSummaryCard: product !== oldState.product,
        footnotes: product !== oldState.product,
    };
};
